import { render, staticRenderFns } from "./CurrentWord.vue?vue&type=template&id=38c3be65&scoped=true&"
import script from "./CurrentWord.vue?vue&type=script&lang=ts&"
export * from "./CurrentWord.vue?vue&type=script&lang=ts&"
import style0 from "./CurrentWord.vue?vue&type=style&index=0&id=38c3be65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c3be65",
  null
  
)

export default component.exports